import { useSelector } from 'react-redux';
import { canActivateResource, canUpdateResource } from 'js/lib/flowValidationUtils';

export default function useFlows() {
  const flowNodes = useSelector((state: any) => state.entities.flowNodes);

  function getFlowById(flowId) {
    return flowNodes[flowId];
  }

  function checkCanActivateFlow(flowId) {
    const flow = flowNodes[flowId];
    return canActivateResource(flow);
  }

  function checkCanUpdateFlow(flowId) {
    const flow = flowNodes[flowId];
    return canUpdateResource(flow);
  }

  return {
    getFlowById,
    flowNodes,
    checkCanActivateFlow,
    checkCanUpdateFlow,
  };
}
